module.exports = __webpack_public_path__ + "img/35.e96d8185.png";